import { compose, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { fetchTotalCartQuantity } from 'reducers/cart/actions';
import { totalCartQuantity } from 'reducers/cart/selectors';
import combineSelectors from 'utils/combineSelectors';

function componentDidMount() {
  this.props.fetchTotalCartQuantity();
}

const mapStateToProps = combineSelectors({
  totalCartQuantity,
});

export default compose(
  connect(mapStateToProps, { fetchTotalCartQuantity }),
  lifecycle({ componentDidMount }),
);
